import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { useMutation, useQueryClient } from 'react-query';
import { OrganizationKeys } from './organization.keys';

export const useDeleteOrganizationLicense = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ licenseId }: { licenseId: string }) =>
      clients.admin.delete(`/organizationLicenses/${licenseId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: OrganizationKeys.orgLicensesCollections(),
        });
      },
    },
  );
};
